import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  IClient,
  ICustomerLoginDto,
  ILoginDto,
  IUserDto,
} from 'src/app/core/models';
import { CommonConstants } from 'src/app/shared/constant';
import {
  AuthService,
  ClientService,
  ToastService,
} from 'src/app/core/services';

@Component({
  selector: 'ic-otp-login',
  templateUrl: './otp-login.component.html',
  styleUrls: ['./otp-login.component.scss'],
})
export class OtpLoginComponent implements OnInit {
  public loginOtpForm: FormGroup;
  public formErrors: any = {};
  public clientConfig: IClient;
  public customerLogin = {} as ICustomerLoginDto;
  public deliveryType = CommonConstants.DeliveryType;

  constructor(
    private readonly fb: FormBuilder,
    private readonly clientService: ClientService,
    private readonly toastService: ToastService,
    private readonly authService: AuthService,
    public readonly activeDialog: NgbActiveModal
  ) {
    this.clientConfig = this.clientService.currentClientValue;
    this.customerLogin.restaurantId = this.clientConfig.restaurantId;
  }

  ngOnInit() {
    this.loginOtpForm = this.fb.group({
      mobile: [
        '',
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern(/^(?![01])\d{10}$/),
        ],
      ],
      otp: [''],
      name: [''],
      email: [''],
      tc: [true, Validators.requiredTrue],
    });

    // This forces validation.
    Object.keys(this.loginOtpForm.controls).forEach((key) => {
      this.loginOtpForm.get(key).markAsTouched();
    });

    this.loginOtpForm.valueChanges.subscribe((changes) => {
      Object.keys(changes).forEach((controlName) => {
        const control = this.loginOtpForm.controls[controlName];
        this.formErrors[controlName] =
          (control.touched || control.dirty) && control.errors ? 'error' : null;
      });
    });
  }

  closeDialog() {
    this.activeDialog.close();
  }

  get fc() {
    return this.loginOtpForm.controls;
  }

  trimEmail() {
    const val = this.loginOtpForm.get('email').value.trim();
    this.loginOtpForm.get('email').setValue(val);
  }

  changeNumber() {
    this.customerLogin.isToken = false;
    this.customerLogin.token = null;
    this.loginOtpForm.get('mobile').enable();
    this.loginOtpForm.get('otp').clearValidators();
    this.loginOtpForm.get('otp').setValue('');
    this.loginOtpForm.updateValueAndValidity();
  }

  resendOtp(status: boolean) {
    this.customerLogin.token = null;
    this.customerLogin.isCall = status;
    this.validateCustomerLogin();
  }

  onSubmit() {
    if (this.customerLogin.isVerified && this.customerLogin.isNew) {
      const model: IUserDto = {
        ...this.loginOtpForm.getRawValue(),
      };
      model.restaurantId = this.clientConfig?.restaurantId;
      model.password = CommonConstants.password;
      model.isMobileVerified = true;
      this.authService.register(model).subscribe(
        (result) => {
          if (result.isSuccess) {
            // this.toastService.showSuccess(
            //   'Registration done successfully! Email verification sent'
            // );
            this.login();
            this.activeDialog.close();
          } else {
            this.toastService.showError(result.errors[0]);
          }
        },
        (err) => {
          this.toastService.showError(
            'Server Error! Please try after sometime'
          );
        }
      );
    } else {
      this.validateCustomerLogin();
    }
  }

  validateCustomerLogin() {
    this.customerLogin.mobile = this.loginOtpForm.get('mobile').value;
    this.customerLogin.otp = this.loginOtpForm.get('otp').value;
    this.authService.validateCustomerLogin(this.customerLogin).subscribe(
      (data) => {
        if (data.isSuccess) {
          this.customerLogin = data.result;
          if (!data.result.isVerified) {
            this.toastService.showSuccess(
              this.customerLogin.isCall
                ? 'Call Initiated'
                : 'OTP sent successfully'
            );
            this.loginOtpForm.get('mobile').disable();
            this.loginOtpForm
              .get('otp')
              .setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(4),
              ]);
            this.loginOtpForm.updateValueAndValidity();
          } else {
            if (this.customerLogin.isNew) {
              this.loginOtpForm
                .get('name')
                .setValidators([Validators.required, Validators.maxLength(50)]);
              this.loginOtpForm
                .get('email')
                .setValidators([
                  Validators.required,
                  Validators.maxLength(50),
                  Validators.email,
                ]);
              this.loginOtpForm.updateValueAndValidity();
            } else {
              this.login();
            }
          }
        } else {
          this.toastService.showError(data.errors[0]);
        }
      },
      (err) => {
        this.toastService.showError(err.exceptionMessage || err.message);
      }
    );
  }

  login() {
    if (!this.clientConfig || !this.clientConfig?.restaurantId) {
      this.toastService.showInfo('Please wait.. Reloading');
      location.reload();
      return;
    }
    const credentials = {} as ILoginDto;
    credentials.username = this.customerLogin.mobile;
    credentials.restaurantId = this.clientConfig?.restaurantId.toString();
    credentials.roleId = CommonConstants.Role.Customer.toString();
    credentials.otpLogin = 'true';
    this.authService.login(credentials).subscribe(
      (result) => {
        if (result) {
          this.closeDialog();
        } else {
          this.toastService.showError('Invalid Role Access');
        }
      },
      (err) => {
        this.toastService.showError(
          err.error.error || err.error.error_description
        );
      }
    );
  }

  getButtonText() {
    let buttonText = 'Continue';
    if (this.customerLogin.isToken) {
      buttonText = 'Verify';
    }
    if (this.customerLogin.isVerified && this.customerLogin.isNew) {
      buttonText = 'Submit';
    }
    return buttonText;
  }
}
